import { Grid, Button, TextField, IconButton } from "@material-ui/core";
import { IconPlus, IconX } from "@tabler/icons-react";
import EditiconButton from "../../../components/common/icon-buttons/EditIconButton";
import CustomTable, {
  RowItemType,
} from "../../../components/common/table/CustomTable";
import { Cliente } from "../../../interfaces/clientes/cliente.interface";
import { useGetClientsQuery } from "../../../services/clients/clientsServices";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  setPageTableClientes,
  setSizeTableClientes,
} from "../slices/clientesSlice";

import { useState } from "react";
import CustomDialog from "../../../components/common/dialogs/CustomDialog";
import AddClientForm from "./AddClientForm";

const ClientsTable = () => {
  const dispatch = useAppDispatch();
  const [searchClient, setSearchClient] = useState<string>();
  const [clientToEdit, setClientToEdit] = useState<Cliente>();
  const [showAddForm, setShowAddForm] = useState(false);

  const { page, size } = useAppSelector((state) => state.clientes);

  const { data, isLoading, isFetching, refetch, isError } = useGetClientsQuery(
    {
      page,
      size,
      search: searchClient,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const handleEditClient = (cliente: Cliente) => {
    setClientToEdit(cliente);
  };

  const handleClickAddClient = () => {
    setClientToEdit(undefined);
    setShowAddForm(true);
  };

  const rows: RowItemType[] =
    data?.data?.map((el, index) => ({
      number: index + 1 + page * size,
      id: String(el.id),
      name: el.nombre || "-",
      ruc: el.ruc || "-",
      correos:
        el.correos !== undefined && el.correos?.length > 0
          ? String(el.correos).replaceAll(";", ", ")
          : "-",
      options: (
        <>
          <EditiconButton size="small" onClick={() => handleEditClient(el)} />
        </>
      ),
    })) || [];

  const headers = [
    {
      id: "number",
      disablePadding: false,
      label: "#",
      numeric: false,
    },
    {
      id: "id",
      disablePadding: false,
      label: "ID",
      numeric: false,
      hidden: true,
    },
    {
      id: "name",
      disablePadding: false,
      label: "NOMBRE",
      numeric: false,
    },
    {
      id: "ruc",
      disablePadding: false,
      label: "RUC",
      numeric: true,
    },
    {
      id: "correos",
      disablePadding: false,
      label: "CORREOS",
      numeric: false,
    },
    {
      id: "options",
      disablePadding: false,
      label: "OPCIONES",
      numeric: false,
    },
  ];

  const clearSearchClient = () => {
    setSearchClient("");
  };

  return (
    <>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Buscar Empresa"
          variant="outlined"
          placeholder="(Nombre - RUC)"
          value={searchClient}
          onChange={(e) => setSearchClient(e.target.value)}
          InputProps={{
            endAdornment: searchClient && searchClient.length > 0 && (
              <IconButton children={<IconX />} onClick={clearSearchClient} />
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} md={12} lg={12} style={{ textAlign: "right" }}>
        <Button
          onClick={handleClickAddClient}
          variant="contained"
          color="primary"
          startIcon={<IconPlus />}
        >
          Crear Empresa
        </Button>
      </Grid>
      <Grid item xs={12} md={12} lg={12}>
        <CustomTable
          dense={true}
          isLoading={isLoading || isFetching}
          isError={isError}
          rows={rows}
          headers={headers}
          totalRecords={Number(data?.total) || 5}
          page={page}
          rowsPerPage={size}
          onChangePage={(page) => dispatch(setPageTableClientes(page))}
          onChangeRowsPerPage={(rowsPerPage) =>
            dispatch(setSizeTableClientes(rowsPerPage))
          }
        />
      </Grid>
      {clientToEdit ? (
        <CustomDialog
          isOpen={Boolean(clientToEdit)}
          handleClose={() => setClientToEdit(undefined)}
          title="Editar Empresa"
          hideActionButtons
        >
          <AddClientForm clientToEdit={clientToEdit} refetchList={refetch} />
        </CustomDialog>
      ) : null}
      <CustomDialog
        isOpen={showAddForm}
        handleClose={() => setShowAddForm(false)}
        title="Crear Empresa"
        hideActionButtons
      >
        <AddClientForm refetchList={refetch} />
      </CustomDialog>
    </>
  );
};

export default ClientsTable;
